// Types
export const TYPE_HOME = 1;
export const TYPE_WORK = 2;
export const TYPE_CELL = 3;
export const TYPE_EMAIL_HOME = 4;
export const TYPE_EMAIL_WORK = 42;
export const TYPE_IMAGE_JPG = 5;
export const TYPE_IMAGE_JPEG = 6;
export const TYPE_IMAGE_PNG = 7;
export const TYPE_IMAGE_BMP = 8;
export const TYPE_IMAGE_GIF = 9;
export const TYPE_VISA = 14;
export const TYPE_MASTERCARD = 15;
export const TYPE_AMEX = 16;
export const TYPE_DISCOVER = 17;
export const TYPE_PATIENT = 18;
export const TYPE_MEMBER = 19;
export const TYPE_ORGANIZATION = 135;
export const TYPE_CONNECTED_PARTY = 20;
export const TYPE_EMAIL = 21;
export const TYPE_UNKNOWN = 22;
export const TYPE_DIRECT_MESSAGE = 23;
export const TYPE_PARENT_STEPPARENT = 30;
export const TYPE_USER_OTHER = 36;
export const TYPE_ALERT_TYPE_URGENT = 46;
export const TYPE_ALERT_TYPE_INFO = 47;
export const TYPE_ATTACHMENT_PDF = 45;
export const TYPE_ATTACHMENT_FORM = 127;

// Channel
export const TYPE_SMS = 10;
export const TYPE_LANDLINE = 11;
export const TYPE_SECURE = 54;
export const TYPE_FACEBOOK = 13;
export const TYPE_TWILIO = 12;
export const TYPE_RHINOGRAM = 134;

// Group
export const TYPE_GROUP_INBOX = 59;
export const TYPE_GROUP_CHAT = 60;
export const TYPE_GROUP_INBOX_AND_CHAT = 61;

// Events
export const TYPE_EVENT_MESSAGE = 26;
export const TYPE_EVENT_NOTE = 27;
export const TYPE_EVENT_SECURE = 28;
export const TYPE_EVENT_HIPAA_CONSENT = 51;
export const TYPE_EVENT_ASSIGNMENT = 67;
export const TYPE_EVENT_RHINOPAY_CONSENT = 90;
export const TYPE_EVENT_MARKETING_CONSENT = 104;
export const TYPE_VIDEO_CHAT_COMPLETED = 110;
export const TYPE_SAVED_CONTENT_SENT = 123;
export const TYPE_EVENT_FORM = 129;

// HIPAA Consent Statuses
export const TYPE_HIPAA_CONSENT_PENDING = 48;
export const TYPE_HIPAA_CONSENT_GRANTED = 49;
export const TYPE_HIPAA_CONSENT_DECLINED = 50;

// Appointment Statuses
export const TYPE_APPOINTMENT_UNCONFIRMED = 81;
export const TYPE_APPOINTMENT_CONFIRMED = 82;
export const TYPE_APPOINTMENT_CANCELLED = 83;
export const TYPE_APPOINTMENT_STATUS_UPDATED_BY_MEMBER = 88;

// Event Statuses
export const TYPE_EVENT_STATUS_ASSIGNMENT = 37;
export const TYPE_EVENT_STATUS_DELIVERED = 38;
export const TYPE_EVENT_STATUS_CONFIRMED_DELIVERED = 39;
export const TYPE_EVENT_STATUS_ERROR = 40;
export const TYPE_EVENT_STATUS_CONFIRMED_ERROR = 41;

// Tags
export const TYPE_TAG_LOCATIONS = 55;
export const TYPE_TAG_ROLES = 56;
export const TYPE_TAG_DEPARTMENTS = 57;
export const TYPE_TAG_CUSTOM = 58;

// Type Classes
export const TYPE_CLASS_PHONE = 1;
export const TYPE_CLASS_EMAIL = 2;
export const TYPE_CLASS_FACEBOOK = 7;
export const TYPE_CLASS_RHINOGRAM = 31;
export const TYPE_CLASS_USER = 6;
export const TYPE_CLASS_CONNECTION = 10;

// Integration Partners
export const TYPE_INTEGRATION_MI7 = 70;
export const TYPE_INTEGRATION_SIKKA = 71;
export const TYPE_INTEGRATION_TOPS = 72;
export const TYPE_INTEGRATION_CLOUD_9 = 76;
export const TYPE_INTEGRATION_EPIC = 101;
export const TYPE_INTEGRATION_FOCUS_ORTHO = 102;
export const TYPE_INTEGRATION_CSV_IMPORT = 111;
export const TYPE_INTEGRATION_NEXTECH = 109;
export const TYPE_INTEGRATION_OPEN_DENTAL = 124;
export const TYPE_INTEGRATION_DOLPHIN = 136;

// Other
export const TYPE_NON_MEMBERS = `${TYPE_PATIENT},${TYPE_UNKNOWN},${TYPE_USER_OTHER}, ${TYPE_ORGANIZATION}`;

// Type Templates
export const TYPE_TEMPLATE_SYSTEM = 94;
export const TYPE_TEMPLATE_CONTACT = 95;
export const TYPE_TEMPLATE_TEAM = 96;


// RhinoPayStatusType
export const TYPE_RHINOPAY_CONSENT_PENDING = 91;
export const TYPE_RHINOPAY_CONSENT_GRANTED = 92;
export const TYPE_RHINOPAY_CONSENT_DECLINED = 93;

// MarketingStatusType
export const TYPE_MARKETING_CONSENT_PENDING = 105;
export const TYPE_MARKETING_CONSENT_GRANTED = 106;
export const TYPE_MARKETING_CONSENT_DECLINED = 107;

// connected party relationship updates
export const TYPE_UPDATED_BY_MEMBER = 98;

// mentions
export const TYPE_MENTION_USER = 99;
export const TYPE_MENTION_ALL = 100;
export const TYPE_MENTION_GROUP = 126;

// Library
export const TYPE_USER_LIBRARY_SAVED_CONTENT = 130;
export const TYPE_USER_LIBRARY_FORM = 131;

export const TYPE_APPOINTMENT_NOTIFICATION = 132;
